import { Reducer } from 'redux';
import {
  CarModelsState,
  GET_CAR_MODELS_LIST,
  CarModelActionTypes,
  GET_CAR_MODEL,
  POST_CAR_MODEL,
  PUT_CAR_MODEL,
  DELETE_CAR_MODEL,
  UPDATE_CAR_MODEL_FILTERS
} from '../types/carmodel.types';

const initialState: CarModelsState = {
  carModels: [],
  selectedCarModel: null,
  postSuccess: null,
  lastFetch: null,
  totalElements: 0,
  totalPages: 1,
  filters: null
};

export const carModelsReducer: Reducer<CarModelsState> = (
  state: CarModelsState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as CarModelActionTypes).type) {
    case GET_CAR_MODELS_LIST:
      return {
        ...state,
        carModels: action.payload.page.content,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalPages: action.payload.page.totalPages,
        totalElements: action.payload.page.totalElements
      };
    case GET_CAR_MODEL:
      return {
        ...state,
        postSuccess: null,
        selectedCarModel: action.payload.selectedCarModel,
        lastFetch: timeOfAction
      };
    case POST_CAR_MODEL:
      return {
        ...state,
        postSuccess: true,
        selectedCarModel: action.payload.newCarModel,
        lastFetch: timeOfAction
      };
    case PUT_CAR_MODEL:
      return {
        ...state,
        selectedCarModel: action.payload.selectedCarModel,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_CAR_MODEL:
      return {
        ...state,
        selectedCarModel: null,
        lastFetch: timeOfAction
      };
    case UPDATE_CAR_MODEL_FILTERS:
      return {
        ...state,
        filters: action.payload.filters
      };
    default:

      return state;
  }
};
